/**
 * 
 * @param {Object[]} data - array of table data
 * @param {function} setValidationErrors - sets validation errors in parent component
 * 
 * @returns {boolean} returns true if table data passes validation, false if there are errors
 */
export const validatePoiTable = (data, setValidationErrors) => {

      const requiredFields = ['POI_Name', 'Click_Point_Lat', 'Click_Point_Lng']
      const validationErrors = [];
  
      //check data against required items in schema
      //if a required item has not been filled out, add to errors
      data.forEach((row, rowIndex) => {

        //only want to validate POIs, not AGMs
        if(row.AGMID) return
  
        requiredFields.forEach((field) => {
          if (row[field].length === 0) {
              validationErrors.push({ row: rowIndex, column: field });
          }
        });


  
      });
      //if errors were found, update validationErrors state and return false
      if(validationErrors.length > 0){
          setValidationErrors(validationErrors)
  
          return false
      }
  
      //if no errors, return true, set validationErrors state to empty
      setValidationErrors([])
      return true
  
    };